import React, { useEffect, useState } from 'react';
import { usersDesignationServices } from '../../../APIServices/usersDesignationServices';
import { useToast } from '../../../hooks/useToast';

function AddNewDesignation({ getUserDesignationData, setModalOpen, category}) {
  const toast = useToast();
  const [buttonLoader, setButtonLoader] = useState(false);
  const [designation, setDesignation] = useState("");

  const addNewUserDesignation = async () => {
    setButtonLoader(true);
    try {
      let userData = {};
      userData.designation = designation;
      userData.category = category;
      let data = await usersDesignationServices.addNewUserDesignation(userData);
      if (data?.statusCode === 200) {
        toast(data?.customMessage || 'Designation added successfully.', 'ok');
        setDesignation("");
        getUserDesignationData();
        setModalOpen("");
      } else {
        toast(data?.customMessage || 'Unable to add designation.', 'warn');
      }
    } catch (error) {
      toast('Unable to add designation. Please try again.', 'warn');
    } finally {
      setButtonLoader(false);
    }
  };

  return (
    <div
      className="modal-backdrop"
      onClick={() =>
        setModalOpen("")
      }
    >
      <div
        className="modal"
        style={{ maxWidth: 480 }}
        onClick={(e) =>
          e.stopPropagation()
        }
      >
        <div className="modal-head">
          <div>
            <div className="modal-title">
              Add Designation
            </div>

            <div className="xs muted">
              Create a new role for the platform
            </div>
          </div>

          <button
            className="icon-btn"
            onClick={() =>
              setModalOpen("")
            }
          >
            <i className="ti ti-x" />
          </button>
        </div>

        <div className="modal-body">
          <div className="field">
            <label className="field-label">
              Designation Name
              <span className="req">
                *
              </span>
            </label>
            <input
              className="inp"
              autoFocus
              disabled={buttonLoader}
              placeholder="e.g., Clinical Lead"
              value={designation}
              onChange={(e) => setDesignation(e.target.value)}
            />
          </div>
        </div>

        <div className="modal-foot">
          <button
            className="btn btn-ghost"
            onClick={() =>
              setModalOpen("")
            }
          >
            Cancel
          </button>
          <button
            className="btn btn-primary d-flex align-items-center justify-content-center gap-2"
            onClick={() => addNewUserDesignation()}
            disabled={buttonLoader || !designation}
          >
            {buttonLoader ? (
              <>
                <div className="buttonLoader"></div>
                <span>Adding...</span>
              </>
            ) : (
              <>
                <i className="ti ti-check"></i>
                <span>Add Designation</span>
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
}

export default AddNewDesignation;
